import downloadDataService from "./downloadDataService";

const cropCertificationDataDownloadService = [
    ...downloadDataService
]

export default cropCertificationDataDownloadService;